import React, { useRef, useEffect } from 'react';
import { useGameStore } from '../store/gameStore';

const BackgroundMusic: React.FC = () => {
  const { settings } = useGameStore();
  const audioRef = useRef<HTMLAudioElement>(null);

  // RNB Melody Track
  const musicUrl = "/audio/looperman-l-6341294-0399844-feelings-rnb-melody-part-1-loop-set.mp3";

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      audio.volume = 0.3; // Fixe Lautstärke
      audio.loop = true;
    }
  }, []);

  useEffect(() => {
    const audio = audioRef.current;
    if (audio) {
      if (settings.musicEnabled) {
        audio.play().catch(console.error);
      } else {
        audio.pause();
      }
    }
  }, [settings.musicEnabled]);

  return (
    <div>
      <audio
        ref={audioRef}
        src={musicUrl}
        preload="metadata"
      />
    </div>
  );
};

export default BackgroundMusic; 